import { AuthServer } from '@services/auth-server.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Constants } from '@utils/constants';

@Component({
  selector: 'app-virtual-keyboard',
  templateUrl: './virtual-keyboard.component.html'
})
export class VirtualKeyboardComponent implements OnInit {

  @Output() onKeyChange = new EventEmitter<any>();
  @Output() onError = new EventEmitter<boolean>();
  @Output() onReady = new EventEmitter<boolean>();
  @Input() typeSignature: any;

  loading = true;
  inputToShow = '';
  keysList = [];
  model: any = {};
  maxChar = 0;

  constructor(
    private _authServer: AuthServer
  ) { }

  ngOnInit() {
    switch (this.typeSignature) {
      case Constants.ELETRONIC_SIGNATURE_TYPES.virtual_keyboard:
        this.model = { hashTeclado: '', keys: [] };
        this.maxChar = 10;
        this.fillKeyboard();
        break;
      case Constants.ELETRONIC_SIGNATURE_TYPES.string:
        this.maxChar = 6;
        this.loading = false;
        this.onReady.emit(true);
        break;
      default:
        break;
    }
  }

  fillKeyboard() {
    this._authServer.iEletronicSignature.getSignatureParameters()
      .subscribe(response => {
        if (response) {
          const tempObj = JSON.parse(response.SerializedObject);
          this.keysList = tempObj.Teclas;
          this.model.hashTeclado = tempObj.HashTeclado;
          this.loading = false;
          this.onReady.emit(true);
        }
      }, error => {
        this.onError.emit(true);
      });
  }

  onBtnClick(key) {
    if (this.inputToShow.length < this.maxChar) {
      this.inputToShow = this.inputToShow + ' *';
    } else {
      return false;
    }
    this.model.keys.push(key.Hash);
    this.onKeyChange.emit(this.model);
  }

  validateSignatureValid(signature: string) {
    if (signature && signature.length <= this.maxChar) {
      this.inputToShow = signature;
    } else {
      return false;
    }
    this.model.keys = signature;
    this.onKeyChange.emit(this.model);
  }

  clearInput() {
    this.inputToShow = '';
    this.model.keys = [];
    this.onKeyChange.emit(this.model.keys);
  }

}
